import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "animate.css/animate.min.css";
import { WOW } from "wowjs";

import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import LoadTop from "../components/ScrollToTop/LoadTop";

import { Error, HomeThreeOnePage } from "../pages";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  //preloader
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  //Initialize wow
  useEffect(() => {
    new WOW({ live: false, animateClass: "animate__animated" }).init();
  }, [location]);

  return (
    <div className="App">
      {isLoading && <Preloader />}
      <ScrollToTop />
      <LoadTop />
      <Routes>
        <Route path="/" element={<HomeThreeOnePage />} />

        <Route path="*" element={<Error />} />
      </Routes>
    </div>
  );
}

export default App;
